<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qXgTC8/tc-custom/9781625853547.jpg?1737918820123" alt="This image is the cover for the book Wild Women of Prescott, Arizona"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wild Women of Prescott, Arizona
      </h1>
      <p class="bookDescription body article font2">
        <b>“Western prostitution historian Jan MacKell Collins tells the stories of the many ‘horizontal experts’ of Prescott.” —<i>True West</i></b><br/>  <br/> Arizona remained a raw, rather uncivilized territory before it became one of the last states to enter the Union. Few towns exemplify this more than Prescott. Untamed land lured those who saw an opportunity to prosper, including a number of shady ladies. A staple of any western town, these wanton women were independent, hearty individuals eager to unpack their petticoats and set up shop. Within six years of establishment, at least five prostitutes operated in Prescott. As their clientele grew, so did their influence. Mollie Sheppard, Lida Winchell, Gabriell Dollie and many more women were integral forces on the city that should not be forgotten. From Granite Street to Whiskey Row, Prescott’s painted ladies established an ever-expanding red-light district halted only by Arizona’s admission to the Union in 1912. Join author Jan MacKell Collins to discover the soiled doves of Prescott’s red-light district.<br/>  <br/><b>“Both Victor and Cripple Creek had active Red Light Districts in the gold rush days and Collins has captured several of the true stories of those who conducted business in the brothels and cribs.” —<i>PeakRadar.com</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan MacKell Collins
      </h2>
      
      <p class="authorDescription body article">Native Arizonian Jan MacKell Collins is an author and historian whose work focuses on prostitution history and other interesting aspects of the West. Author of over two thousand magazine articles, her writing appears in Colorado Gambler Magazine, Kiva Magazine and True West Magazine. Her 2009 book Red Light Women of the Rocky Mountains was nominated for a WILLA award by Women Writing the West in 2011 she was a co-nominee for the 2010 anthology, Extraordinary Women of the Rocky Mountain West.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?932d92e8